(function () {
  'use strict'

  /**
     * @ngdoc directive
     * @name thismomentGlowModuleEmbed
     * @module thismoment.glow.component.module.embed
     *
     * @description
     * The embed module for glow
     *
     * @example <pre><code>&#x3C;thismoment-glow-embed id=&#x22;1&#x22;&#x3E;&#x3C;/thismoment-glow-embed&#x3E;</code></pre>
     */

  const MODULE_NAME = 'thismoment.glow.component.module.embed'
  const templateUrl = require('./tpl/module-embed.html')

  require('dynamic-bind-html')
  require('./scss/module-embed.scss')

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml', // ಠ_ಠ
      require('../../../../embed')
    ])
    .component('thismomentGlowModuleEmbed', {
      templateUrl: templateUrl,
      bindings: {
        trackEvent: '&',
        moduleId: '<',
        name: '<',
        allowScrolling: '<',
        height: '<',
        margin: '<',
        mobileHeight: '<',
        mobileMargin: '<',
        url: '<'
      },
      controller: glowEmbedController
    })

  glowEmbedController.$inject = ['$window', '$rootScope', '$sce', '$scope', 'SdkConfig']
  function glowEmbedController ($window, $rootScope, $sce, $scope, SdkConfig) {
    const vm = this

    $scope.$on('breakpoint:resize', function () {
      embedInit()
      $scope.$apply()
    })

    vm.$onInit = embedInit
    vm.embedCallbackCalled = false
    function embedInit () {
      const src = vm.url
      const embedDetectorId = 'embed-detect-' + vm.moduleId
      var height
      var margin

      vm.styles = vm.classes = {}
      vm.scrolling = (vm.allowScrolling) ? 'yes' : 'no'
      vm.renderCallback = renderCallback
      vm.trustSrc = trustSrc
      vm.modalPop = modalPop
      vm.modalUgcPop = modalUgcPop

      if (isUrl(src)) {
        vm.isUrl = true
        vm.iframeUrl = src
        vm.classes.wrapper = ['embed-responsive', 'embed-responsive-16by9']
        // don't check for embedded callbacks for iframes
        vm.embedCallbackCalled = true
      } else {
        vm.isHtml = true
        vm.html = '<span id="' + embedDetectorId + '"></span>' + src
      }

      switch (SdkConfig.get('breakpoint')) {
        case 'xs':
        case 'sm':
          height = vm.mobileHeight || vm.height
          margin = vm.mobileMargin || vm.margin
          break

        case 'md':
        case 'lg':
          // styles
          height = vm.height
          margin = vm.margin
          break
      }

      vm.styles = {
        wrapper: {
          height: height + 'px',
          margin: margin
        }
      }

      function modalPop (event, playlistId, contentId) {
        if (typeof playlistId !== 'string') {
          playlistId = playlistId.toString()
        }
        if (typeof contentId !== 'string') {
          contentId = contentId.toString()
        }
        $rootScope.$broadcast('modal-content-pop', playlistId, contentId, event)
      }

      function modalUgcPop (event, ugcId) {
        if (typeof ugcId !== 'number') {
          ugcId = parseInt(ugcId, 10)
        }
        $rootScope.$broadcast('modal-ugc-pop', ugcId, event)
      }

      function isUrl (str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator

        return pattern.test(str)
      }

      function renderCallback () {
        if (vm.embedCallbackCalled) {
          return
        }

        if (angular.isUndefined($window['embedCallback' + vm.moduleId])) {
          vm.embedCallbackCalled = true
          return
        }

        const elDetect = document.getElementById(embedDetectorId)
        if (elDetect !== null) {
          $window['embedCallback' + vm.moduleId]()
          vm.embedCallbackCalled = true
        }
      }

      function trustSrc (src) {
        return $sce.trustAsResourceUrl(src)
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-embed/index.js